<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Funds Transfer</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <FundsTransferTab />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import FundsTransferTab from "../../components/Kleyton/Tabs/FT/FundsTransferTab";

export default {
  page: {
    title: "Funds Transfer",
    meta: [{ name: "Funds Transfer", content: window.__env.app.description }],
  },

  components: {
    FundsTransferTab,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "FundsTransfer",
      title: "Transfer Funds",
      items: [
        {
          text: "Funds Transfer",
          href: "/"
        },
        {
          text: "Transfer Funds",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
